import { useTranslation } from 'react-i18next';

import { XMarkIcon } from '@heroicons/react/24/solid';
import { useOutletContext } from '@remix-run/react';

import type { OutletContext } from '~/interfaces/outlet_context';

const PreviewHelperNote = () => {
  const { t } = useTranslation();
  const { setCookie } = useOutletContext<OutletContext>();

  return (
    <div className="relative mb-4 space-y-2 rounded bg-blue-100 px-6 py-4 text-blue-900">
      <div className="absolute right-4 top-4">
        <button
          type="button"
          onClick={() => {
            setCookie({
              name: 'form_preview_banner_disabled',
              value: 'true',
              days: 30,
            });
          }}
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      </div>

      <p className="text-xs">
        <span className="font-bold">{t('forms.helper.p1_part1')}:</span> {t('forms.helper.p1_part2')}
      </p>
      <p className="text-xs">
        {t('forms.helper.p2_part1')} <span className="font-bold">{t('forms.helper.p2_part2')}</span>,{' '}
        {t('forms.helper.p2_part3')} <span className="font-bold">{t('forms.helper.p2_part4')} </span>
        {t('forms.helper.p2_part5')}
      </p>

      <p className="text-xs">{t('forms.helper.p3_part1')} </p>
    </div>
  );
};

export default PreviewHelperNote;
